import { supabase } from '@/auth/supabase'
import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context, location }) => {
    if (!context.session) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      })
    }

    // Don't redirect if user is already on the initial-preferences page
    if (context.session.user && location.pathname !== '/initial-preferences') {
      const userId = context.session.user.id

      // Use the query client to fetch user preferences (will use cache if available)
      const profile = await context.queryClient.ensureQueryData({
        queryKey: ['user-preferences', userId],
        queryFn: async () => {
          const { data, error } = await supabase
            .from('user_preferences')
            .select('*')
            .eq('user_id', userId)
            .single()

          if (error) {
            if (error.code === 'PGRST116') {
              return null
            }
            throw error
          }

          return data
        },
        staleTime: 5 * 60 * 1000,
      })

      if (!profile) {
        throw new Error('User profile not found')
      }

      if (!profile.was_prompted) {
        throw redirect({
          to: '/initial-preferences',
        })
      }
    }
  },
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  return <Outlet />
}
